import { PortfolioBankAccount } from '@/api/portfolios/models/PortfolioBankAccount';

export const createPortfolioBankAccountLabel = (
  portfolioBankAccount: PortfolioBankAccount,
): string => {
  return `${portfolioBankAccount.currency} - ${portfolioBankAccount.accountNumber} - ${portfolioBankAccount.bankName}`;
};
